var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7502 16.725L17.5252 15.5C18.3752 15.3333 19.0835 14.9333 19.6502 14.3C20.2169 13.6667 20.5002 12.925 20.5002 12.075C20.5002 11.1083 20.1585 10.2833 19.4752 9.6C18.7919 8.91667 17.9669 8.575 17.0002 8.575H13.1252V7.075H17.0002C18.3835 7.075 19.5627 7.5625 20.5377 8.5375C21.5127 9.5125 22.0002 10.6917 22.0002 12.075C22.0002 13.1083 21.7002 14.0417 21.1002 14.875C20.5002 15.7083 19.7169 16.325 18.7502 16.725ZM14.8502 12.825L13.3502 11.325H15.8752V12.825H14.8502ZM20.3502 22.6L1.5752 3.825L2.6502 2.75L21.4252 21.525L20.3502 22.6ZM11.2502 17H7.0002C5.61686 17 4.4377 16.5125 3.4627 15.5375C2.4877 14.5625 2.0002 13.3833 2.0002 12C2.0002 10.8 2.37103 9.74167 3.1127 8.825C3.85436 7.90833 4.8002 7.33333 5.9502 7.1L7.35019 8.5H7.0002C6.03353 8.5 5.20853 8.84167 4.5252 9.525C3.84186 10.2083 3.5002 11.0333 3.5002 12C3.5002 12.9667 3.84186 13.7917 4.5252 14.475C5.20853 15.1583 6.03353 15.5 7.0002 15.5H11.2502V17ZM8.1252 12.75V11.25H10.1002L11.6002 12.75H8.1252Z",
    fill: "#8797AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlink);
export default __webpack_public_path__ + "static/media/unlink.6c626bf1b326d244101214b5217a8106.svg";
export { ForwardRef as ReactComponent };